// ============================================================
//  MASAMADREAM — PWA Install Prompt
//  Fase 4: captura beforeinstallprompt, muestra banner custom
// ============================================================

let _deferredPrompt = null;

export function initPwaPrompt() {
  // Capture the browser's install event
  window.addEventListener('beforeinstallprompt', (e) => {
    e.preventDefault();
    _deferredPrompt = e;

    // Only show banner if not already installed
    if (!isInstalled()) {
      _showBanner();
    }
  });

  // Hide banner once installed
  window.addEventListener('appinstalled', () => {
    _hideBanner();
    _deferredPrompt = null;
  });

  // Wire buttons
  document.getElementById('mm-install-btn')?.addEventListener('click', async () => {
    if (!_deferredPrompt) return;
    _deferredPrompt.prompt();
    const { outcome } = await _deferredPrompt.userChoice;
    if (outcome === 'accepted') {
      _hideBanner();
    }
    _deferredPrompt = null;
  });

  document.getElementById('mm-install-dismiss')?.addEventListener('click', () => {
    _hideBanner();
    // Remember dismissal for this session
    sessionStorage.setItem('mm_install_dismissed', '1');
  });
}

function _showBanner() {
  if (sessionStorage.getItem('mm_install_dismissed')) return;
  const banner = document.getElementById('mm-install-banner');
  if (banner) {
    banner.classList.remove('mm-hidden');
    requestAnimationFrame(() => banner.classList.add('is-visible'));
  }
}

function _hideBanner() {
  const banner = document.getElementById('mm-install-banner');
  if (!banner) return;
  banner.classList.remove('is-visible');
  banner.addEventListener('transitionend', () => {
    banner.classList.add('mm-hidden');
  }, { once: true });
}

function isInstalled() {
  return (
    window.matchMedia('(display-mode: standalone)').matches ||
    window.navigator.standalone === true
  );
}
